import Pages from 'containers/Pages/Pages.jsx';
import Dash from 'containers/Dash/Dash.jsx';
import { AUTH_PATHS } from 'services/AuthService.jsx'

var appRoutes = [
    { path: AUTH_PATHS.LOGIN, name: "Pages", component: Pages, auth: false },
    { path: AUTH_PATHS.REGISTER, name: "Pages", component: Pages, auth: false },
    { path: AUTH_PATHS.FORGOT_PASSWORD, name: "Pages", component: Pages, auth: false },
    { path: AUTH_PATHS.PASSWORD_RESET, name: "Pages", component: Pages, auth: false },
    // { path: "/pages/lock-screen-page", name: "Pages", component: Pages, auth: false },
    { path: "/", name: "Home", component: Dash, auth: true }
];

export default appRoutes;



// WEBPACK FOOTER //
// ./src/routes/app.jsx